// Base de datos de procedimientos quirúrgicos veterinarios
// Basado en protocolos veterinarios estándar para especies caninas y felinas

export const SURGICAL_PROCEDURES = [
  // ==================== TEJIDOS BLANDOS ====================
  {
    id: 'tb_001',
    name: 'Ovariohisterectomía (Esterilización Hembra)',
    category: 'Tejidos Blandos',
    species: ['Canino', 'Felino'],
    description: 'Extracción quirúrgica de ovarios y útero',
    duration: 60,
    complexity: 'Media',
    equipment: [
      'Set de cirugía general',
      'Pinzas de Allis',
      'Porta agujas Mayo-Hegar',
      'Tijeras Mayo',
      'Bisturí',
      'Separadores Farabeuf',
      'Equipo de anestesia'
    ],
    materials: [
      'Suturas absorbibles 2-0 y 3-0',
      'Suturas no absorbibles 3-0 para piel',
      'Gasas estériles',
      'Guantes estériles',
      'Clorhexidina',
      'Suero fisiológico',
      'Vendaje'
    ]
  },
  {
    id: 'tb_002',
    name: 'Orquiectomía (Castración Macho)',
    category: 'Tejidos Blandos',
    species: ['Canino', 'Felino'],
    description: 'Extracción quirúrgica de testículos',
    duration: 30,
    complexity: 'Baja',
    equipment: [
      'Set de cirugía general',
      'Pinzas de Allis',
      'Porta agujas',
      'Tijeras Mayo',
      'Bisturí',
      'Equipo de anestesia'
    ],
    materials: [
      'Suturas absorbibles 3-0',
      'Suturas no absorbibles 3-0',
      'Gasas estériles',
      'Guantes estériles',
      'Clorhexidina',
      'Suero fisiológico'
    ]
  },
  {
    id: 'tb_003',
    name: 'Mastectomía',
    category: 'Tejidos Blandos',
    species: ['Canino', 'Felino'],
    description: 'Extracción de glándulas mamarias afectadas',
    duration: 90,
    complexity: 'Alta',
    equipment: [
      'Set de cirugía general',
      'Electrocauterio',
      'Pinzas hemostáticas múltiples',
      'Separadores Weitlaner',
      'Tijeras Metzenbaum',
      'Aspirador quirúrgico'
    ],
    materials: [
      'Suturas absorbibles 2-0, 3-0',
      'Suturas no absorbibles 2-0, 3-0',
      'Gasas en cantidad',
      'Drenaje Penrose',
      'Vendaje compresivo',
      'Soluciones cristaloides'
    ]
  },
  {
    id: 'tb_004',
    name: 'Gastropexia Profiláctica',
    category: 'Tejidos Blandos',
    species: ['Canino'],
    description: 'Fijación del estómago a pared abdominal',
    duration: 60,
    complexity: 'Media',
    equipment: [
      'Set de cirugía abdominal',
      'Separadores Balfour',
      'Pinzas Babcock',
      'Instrumental de laparoscopía'
    ],
    materials: [
      'Suturas no absorbibles 2-0',
      'Suturas absorbibles 2-0, 3-0',
      'Gasas y compresas',
      'Soluciones antisépticas'
    ]
  },
  {
    id: 'tb_005',
    name: 'Esplenectomía',
    category: 'Tejidos Blandos',
    species: ['Canino', 'Felino'],
    description: 'Extracción quirúrgica del bazo',
    duration: 90,
    complexity: 'Alta',
    equipment: [
      'Set de cirugía abdominal',
      'Pinzas hemostáticas grandes',
      'Ligador de vasos',
      'Aspirador quirúrgico',
      'Electrocauterio'
    ],
    materials: [
      'Suturas absorbibles 2-0, 3-0',
      'Clips vasculares',
      'Gasas y compresas',
      'Cristaloides y coloides',
      'Soluciones hemostáticas'
    ]
  },
  {
    id: 'tb_006',
    name: 'Cistotomía',
    category: 'Tejidos Blandos',
    species: ['Canino', 'Felino'],
    description: 'Apertura vesical para extracción de cálculos',
    duration: 60,
    complexity: 'Media',
    equipment: [
      'Set de cirugía abdominal',
      'Pinzas Babcock',
      'Aspirador',
      'Sonda uretral'
    ],
    materials: [
      'Suturas absorbibles 3-0, 4-0',
      'Sonda Foley',
      'Gasas',
      'Solución salina',
      'Frascos para urianálisis'
    ]
  },

  // ==================== ORTOPEDIA ====================
  {
    id: 'ort_001',
    name: 'Osteosíntesis de Fémur - Placa DCP',
    category: 'Ortopedia',
    species: ['Canino', 'Felino'],
    description: 'Reducción y fijación de fractura femoral',
    duration: 120,
    complexity: 'Alta',
    equipment: [
      'Set de ortopedia completo',
      'Taladro ortopédico',
      'Placas DCP 2.7mm o 3.5mm',
      'Tornillos corticales',
      'Destornilladores',
      'Guías de perforación',
      'Pinzas reductoras',
      'Retractores Hohmann',
      'Fluoroscopio'
    ],
    materials: [
      'Placa DCP según tamaño',
      'Tornillos 3.5mm (8-10 unidades)',
      'Suturas absorbibles 2-0, 3-0',
      'Gasas estériles',
      'Vendaje Robert Jones',
      'Férula externa'
    ]
  },
  {
    id: 'ort_002',
    name: 'TPLO - Osteotomía Nivelación Meseta Tibial',
    category: 'Ortopedia',
    species: ['Canino'],
    description: 'Cirugía para ruptura de ligamento cruzado',
    duration: 150,
    complexity: 'Alta',
    equipment: [
      'Set TPLO específico',
      'Sierra TPLO con hojas',
      'Placas TPLO',
      'Taladro ortopédico',
      'Guías de corte TPLO',
      'Goniómetro',
      'Fluoroscopio'
    ],
    materials: [
      'Placa TPLO específica',
      'Tornillos 3.5mm',
      'Hojas de sierra estériles',
      'Suturas absorbibles',
      'Vendaje compresivo',
      'Hielo terapéutico'
    ]
  },
  {
    id: 'ort_003',
    name: 'Luxación de Rótula - Reconstrucción',
    category: 'Ortopedia',
    species: ['Canino', 'Felino'],
    description: 'Corrección quirúrgica de luxación patelar',
    duration: 90,
    complexity: 'Media',
    equipment: [
      'Set de cirugía ortopédica',
      'Taladro ortopédico',
      'Pines Kirschner',
      'Osteotomo',
      'Retractores'
    ],
    materials: [
      'Suturas no absorbibles 2-0',
      'Alambre ortopédico',
      'Pines K-wire',
      'Suturas absorbibles',
      'Vendaje de soporte'
    ]
  },
  {
    id: 'ort_004',
    name: 'Osteosíntesis de Radio/Ulna',
    category: 'Ortopedia',
    species: ['Canino', 'Felino'],
    description: 'Fijación de fractura de antebrazo',
    duration: 120,
    complexity: 'Alta',
    equipment: [
      'Set de ortopedia',
      'Placas 2.0mm o 2.7mm',
      'Clavos intramedulares',
      'Taladro ortopédico',
      'Pinzas reductoras'
    ],
    materials: [
      'Placas y tornillos',
      'Clavos IM',
      'Cerclajes con alambre',
      'Suturas 3-0, 4-0',
      'Férula Robert Jones'
    ]
  },
  {
    id: 'ort_005',
    name: 'Artrodesis de Carpo/Tarso',
    category: 'Ortopedia',
    species: ['Canino', 'Felino'],
    description: 'Fusión articular para inestabilidad',
    duration: 120,
    complexity: 'Alta',
    equipment: [
      'Set de ortopedia',
      'Placas de artrodesis',
      'Taladro',
      'Fresa ósea',
      'Injerto óseo'
    ],
    materials: [
      'Placa de artrodesis',
      'Tornillos',
      'Injerto óseo autólogo',
      'Suturas',
      'Férula externa'
    ]
  },

  // ==================== DENTAL ====================
  {
    id: 'den_001',
    name: 'Profilaxis Dental con Extracciones',
    category: 'Dental',
    species: ['Canino', 'Felino'],
    description: 'Limpieza dental y extracción de piezas enfermas',
    duration: 60,
    complexity: 'Media',
    equipment: [
      'Equipo de ultrasonido dental',
      'Elevadores dentales',
      'Fórceps dentales',
      'Turbina de alta velocidad',
      'Fresas dentales',
      'Luxadores',
      'Rayos X dental'
    ],
    materials: [
      'Puntas de ultrasonido',
      'Pasta profiláctica',
      'Gasas',
      'Suturas 4-0',
      'Clorhexidina',
      'Gel de flúor'
    ]
  },
  {
    id: 'den_002',
    name: 'Tratamiento de Conducto',
    category: 'Dental',
    species: ['Canino'],
    description: 'Endodoncia en canino fracturado',
    duration: 90,
    complexity: 'Alta',
    equipment: [
      'Equipo de endodoncia',
      'Limas endodónticas',
      'Turbina dental',
      'Micromotor',
      'Localizador de ápice',
      'Rayos X dental'
    ],
    materials: [
      'Gutapercha',
      'Cemento endodóntico',
      'Limas K-file',
      'Hipoclorito de sodio',
      'Material de restauración',
      'Puntas de papel'
    ]
  },
  {
    id: 'den_003',
    name: 'Cirugía Periodontal',
    category: 'Dental',
    species: ['Canino', 'Felino'],
    description: 'Tratamiento de enfermedad periodontal avanzada',
    duration: 60,
    complexity: 'Media',
    equipment: [
      'Instrumental dental',
      'Curetas periodontales',
      'Elevadores',
      'Ultrasonido dental'
    ],
    materials: [
      'Suturas 5-0',
      'Membranas de regeneración',
      'Antibióticos locales',
      'Clorhexidina'
    ]
  },

  // ==================== OFTALMOLOGÍA ====================
  {
    id: 'oft_001',
    name: 'Enucleación',
    category: 'Oftalmología',
    species: ['Canino', 'Felino'],
    description: 'Extracción quirúrgica del globo ocular',
    duration: 45,
    complexity: 'Media',
    equipment: [
      'Set de cirugía oftalmológica',
      'Tijeras de enucleación',
      'Pinzas oftálmicas',
      'Blefarostato'
    ],
    materials: [
      'Suturas 4-0, 5-0',
      'Gasas oftálmicas',
      'Vendaje ocular',
      'Solución salina',
      'Antibiótico oftálmico'
    ]
  },
  {
    id: 'oft_002',
    name: 'Cirugía de Entropión',
    category: 'Oftalmología',
    species: ['Canino', 'Felino'],
    description: 'Corrección de inversión del párpado',
    duration: 30,
    complexity: 'Baja',
    equipment: [
      'Set de cirugía oftalmológica',
      'Blefarostato',
      'Tijeras oftálmicas',
      'Porta agujas oftálmico'
    ],
    materials: [
      'Suturas 5-0 o 6-0',
      'Anestésico local',
      'Pomada oftálmica'
    ]
  },
  {
    id: 'oft_003',
    name: 'Facoemulsificación - Cataratas',
    category: 'Oftalmología',
    species: ['Canino', 'Felino'],
    description: 'Extracción de cristalino opacificado',
    duration: 90,
    complexity: 'Alta',
    equipment: [
      'Microscopio quirúrgico',
      'Facoemulsificador',
      'Set microcirugía ocular',
      'Lentes intraoculares'
    ],
    materials: [
      'Suturas 8-0, 9-0',
      'Lente intraocular',
      'Viscoelástico',
      'Solución BSS'
    ]
  },
  {
    id: 'oft_004',
    name: 'Cirugía de Úlcera Corneal',
    category: 'Oftalmología',
    species: ['Canino', 'Felino'],
    description: 'Reparación de úlcera corneal profunda',
    duration: 45,
    complexity: 'Media',
    equipment: [
      'Microscopio',
      'Instrumental microcirugía',
      'Lente de contacto terapéutico'
    ],
    materials: [
      'Suturas 7-0, 8-0',
      'Membrana amniótica',
      'Lente de contacto',
      'Colirios'
    ]
  },

  // ==================== NEUROLOGÍA ====================
  {
    id: 'neu_001',
    name: 'Hemilaminectomía',
    category: 'Neurología',
    species: ['Canino'],
    description: 'Descompresión medular por hernia discal',
    duration: 120,
    complexity: 'Alta',
    equipment: [
      'Set de neurocirugía',
      'Taladro con fresas',
      'Microscopio quirúrgico',
      'Rongeur',
      'Aspirador',
      'Neuromonitoreo'
    ],
    materials: [
      'Suturas 3-0, 4-0',
      'Hemostáticos (Gelfoam)',
      'Corticoides',
      'Drenaje cerrado'
    ]
  },
  {
    id: 'neu_002',
    name: 'Craneotomía',
    category: 'Neurología',
    species: ['Canino', 'Felino'],
    description: 'Apertura craneal para tumor o trauma',
    duration: 180,
    complexity: 'Alta',
    equipment: [
      'Set neurocirugía craneal',
      'Taladro craneal',
      'Craneotomo',
      'Microscopio',
      'Placas de titanio',
      'Monitor presión intracraneal'
    ],
    materials: [
      'Placas titanio',
      'Suturas 4-0, 5-0',
      'Hemostáticos',
      'Drenaje ventricular',
      'Manitol'
    ]
  },
  {
    id: 'neu_003',
    name: 'Fenestración Discos Intervertebrales',
    category: 'Neurología',
    species: ['Canino'],
    description: 'Prevención de hernias discales',
    duration: 90,
    complexity: 'Media',
    equipment: [
      'Set de neurocirugía',
      'Microscopio',
      'Fresas',
      'Curetas discales'
    ],
    materials: [
      'Suturas 3-0',
      'Hemostáticos',
      'Gasas neurológicas'
    ]
  },

  // ==================== ONCOLOGÍA ====================
  {
    id: 'onc_001',
    name: 'Resección de Masa Cutánea',
    category: 'Oncología',
    species: ['Canino', 'Felino'],
    description: 'Extracción de tumor con márgenes oncológicos',
    duration: 60,
    complexity: 'Media',
    equipment: [
      'Set de cirugía general',
      'Electrocauterio',
      'Bisturí',
      'Pinzas hemostáticas'
    ],
    materials: [
      'Suturas 2-0, 3-0',
      'Frascos para biopsia',
      'Tinta china para márgenes',
      'Gasas'
    ]
  },
  {
    id: 'onc_002',
    name: 'Amputación de Miembro',
    category: 'Oncología',
    species: ['Canino', 'Felino'],
    description: 'Amputación por osteosarcoma',
    duration: 90,
    complexity: 'Alta',
    equipment: [
      'Set ortopédico',
      'Sierra oscilante',
      'Electrocauterio',
      'Ligador de vasos'
    ],
    materials: [
      'Suturas 0, 2-0',
      'Gasas en cantidad',
      'Drenaje cerrado',
      'Vendaje acolchado'
    ]
  },
  {
    id: 'onc_003',
    name: 'Mandibulectomía Parcial',
    category: 'Oncología',
    species: ['Canino', 'Felino'],
    description: 'Resección mandibular por tumor oral',
    duration: 120,
    complexity: 'Alta',
    equipment: [
      'Sierra oscilante',
      'Set dental',
      'Electrocauterio',
      'Placas mandibulares'
    ],
    materials: [
      'Suturas 2-0, 3-0',
      'Sonda nasogástrica',
      'Gasas',
      'Vendaje'
    ]
  },

  // ==================== EMERGENCIA ====================
  {
    id: 'emer_001',
    name: 'Laparotomía Exploratoria',
    category: 'Emergencia',
    species: ['Canino', 'Felino'],
    description: 'Cirugía abdominal de emergencia',
    duration: 90,
    complexity: 'Alta',
    equipment: [
      'Set cirugía abdominal',
      'Aspirador',
      'Electrocauterio',
      'Separadores',
      'Pinzas vasculares'
    ],
    materials: [
      'Suturas 2-0, 3-0',
      'Gasas y compresas',
      'Cristaloides',
      'Sangre (disponible)',
      'Drenaje abdominal'
    ]
  },
  {
    id: 'emer_002',
    name: 'Cesárea de Emergencia',
    category: 'Emergencia',
    species: ['Canino', 'Felino'],
    description: 'Extracción fetal por distocia',
    duration: 45,
    complexity: 'Media',
    equipment: [
      'Set cirugía abdominal',
      'Aspirador',
      'Equipo reanimación neonatal',
      'Incubadora'
    ],
    materials: [
      'Suturas 2-0, 3-0',
      'Gasas',
      'Oxígeno',
      'Calor para neonatos',
      'Pinzas cordón'
    ]
  },
  {
    id: 'emer_003',
    name: 'Gastrotomía por Cuerpo Extraño',
    category: 'Emergencia',
    species: ['Canino', 'Felino'],
    description: 'Extracción de cuerpo extraño gástrico',
    duration: 60,
    complexity: 'Media',
    equipment: [
      'Set cirugía abdominal',
      'Pinzas Babcock',
      'Aspirador',
      'Endoscopio (opcional)'
    ],
    materials: [
      'Suturas 3-0, 4-0',
      'Gasas',
      'Solución salina',
      'Gastroprotectores'
    ]
  },
  {
    id: 'emer_004',
    name: 'Toracotomía de Emergencia',
    category: 'Emergencia',
    species: ['Canino', 'Felino'],
    description: 'Apertura torácica por trauma o hemotórax',
    duration: 120,
    complexity: 'Alta',
    equipment: [
      'Set cirugía torácica',
      'Separadores costales Finochietto',
      'Aspirador potente',
      'Tubos de toracostomía',
      'Monitoreo avanzado'
    ],
    materials: [
      'Suturas 0, 2-0',
      'Tubos de drenaje torácico',
      'Gasas y compresas',
      'Sangre (disponible)',
      'Sistema de vacío'
    ]
  }
];

// Función helper para obtener procedimientos por categoría
export const getProceduresByCategory = (category) => {
  return SURGICAL_PROCEDURES.filter(proc => proc.category === category);
};

// Función helper para obtener procedimientos por especie
export const getProceduresBySpecies = (species) => {
  return SURGICAL_PROCEDURES.filter(proc => proc.species.includes(species));
};

// Función helper para buscar procedimiento por ID
export const getProcedureById = (id) => {
  return SURGICAL_PROCEDURES.find(proc => proc.id === id);
};
